import { LanguageCode, languageCodeStringToEnum } from "@/enums";
import { getTextResources } from "../../../tests/entities";
import { CheckoutInfo, OtpResponse, TextResourceList } from "@/entities";
import { getTranslations, loading, replaceState, translation } from "@/utils/common";
import { defineComponent } from "vue";
import { get } from "@/utils/httpRequest";
import { otpStore } from "@/store";

export default defineComponent({
    name: "ErrorView",
    props: {
        scaSessionId: {
            type: String,
            required: false,
        },
    },
    data: function () {
        return {
            isDeadEnd: false,
            isSmsDisabled: false,
            data: <CheckoutInfo | null>new CheckoutInfo(),
            textResourceList: new TextResourceList(),
            store: otpStore(),
        };
    },
    async created() {
        replaceState();

        this.data = this.store.otp ?? this.data;

        loading();
        try {
            if (this.scaSessionId) {
                const response = <OtpResponse>await get(`api/verifyotp/init/${this.scaSessionId}`);
                this.isDeadEnd = response.isDeadEnd;
                this.isSmsDisabled = response.message == "SmsLimitReached";
                this.data = this.data ?? response.data;
            }
        } catch (e) {
            console.log("Error while loading page data.", e);
        } finally {
            loading();
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            loading();
            try {
                this.textResourceList = (await this.getTextResources(this.data?.countryCode, languageCodeStringToEnum(this.data?.conversationLanguage))) as TextResourceList;
            } catch {
                this.textResourceList = new TextResourceList();
                this.textResourceList.textResourceItems = [
                    { sysName: "OtpErrorTitle", value: "We are sorry! Something went wrong." },
                    { sysName: "OtpErrorSubTitle", value: "An error occurred while processing your request." },
                    { sysName: "OtpRestartButton", value: "Restart" },
                    { sysName: "OtpReturnToShopButton", value: "Return to shop" },
                ];
                return;
            } finally {
                loading();
            }
        },
        reStartVerification() {
            this.$router.replace(`/otp/verifyotpauthentication/init/${this.data?.scaSessionId ?? this.scaSessionId}`);
        },
        redirectToMerchant() {
            if (this.data?.redirectUrl) {
                window.location.replace(this.data.redirectUrl);
            }
        },
        async getTextResources(countryCode: string | null | undefined, languageCode: LanguageCode, agent: unknown | null = null): Promise<TextResourceList | getTextResources> {
            const sysnameList = ["OtpDeadEndErrorTitle", "OtpDeadEndErrorSubTitle", "OtpErrorTitle", "OtpErrorSubTitle", "OtpRestartButton", "OtpReturnToShopButton"];

            return await getTranslations(sysnameList, countryCode, languageCode, agent);
        },
        getTranslation(sysName: string, replace: string[] = []): string {
            return translation(this.textResourceList?.textResourceItems, sysName, replace);
        },
    },
});
